export const GET_GUARDIAN = 'GET_GUARDIAN';
export const SET_USER_GUARDIANS = 'SET_USER_GUARDIANS';
export const UPDATE_GUARDIAN_SETTING = 'UPDATE_GUARDIAN_SETTING';
